import React from "react";
import { Button, SimpleButton } from "../Button";
import Container from "../Container";
import Hamburger from "../Hamburger";
import Search from "../Search";
import WIDGETS from "./widgets";
import { CartContext } from "../CartUtils";
import ButtonClose from "../ButtonClose";
import ClickAway from "../ClickAway";
import SLIM_ICONS from "./SlimIcons";
import s from "./Header.module.css";

const RED_LOGO =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTAiIGhlaWdodD0iOTAiIHZpZXdCb3g9IjAgMCA5MCA5MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkwIDBIMFY5MEg5MFYwWiIgZmlsbD0iI0UxMTYxQyIvPgo8cGF0aCBkPSJNNzkuMTI1OCA0My41NzVDNzcuMzYzMyA0My4zODc1IDc1LjkwMDggNDIuNzEyNSA3NS45MDA4IDQyLjExMjVDNzUuOTAwOCA0MS4yMTI1IDc2Ljg3NTggNDEuMDYyNSA3Ny40NzU4IDQxLjA2MjVDNzguMDM4MyA0MS4wNjI1IDc5LjMxMzMgNDEuMTc1IDc5LjMxMzMgNDIuMzc1Qzc5LjMxMzMgNDIuNDg3NSA3OS4zODgzIDQyLjU2MjUgNzkuNDYzMyA0Mi41NjI1SDgzLjI1MDhDODMuMzI1OCA0Mi41NjI1IDgzLjQwMDggNDIuNDg3NSA4My40MDA4IDQyLjM3NUM4My40MDA4IDM5LjQ4NzUgODAuOTI1OCAzNy41IDc3LjQwMDggMzcuNUM3My45MTMzIDM3LjUgNzEuNDAwOCAzOS40ODc1IDcxLjQwMDggNDIuMjI1QzcxLjQwMDggNDQuNTg3NSA3NC4zNjMzIDQ2LjIzNzUgNzcuMTM4MyA0Ni41Mzc1Qzc4LjM3NTggNDYuNjg3NSA3OS4xMjU4IDQ3LjI4NzUgNzkuMTI1OCA0Ny43Mzc1Qzc5LjEyNTggNDguNDg3NSA3OC4yMjU4IDQ4LjkgNzcuNDAwOCA0OC45Qzc3LjA2MzMgNDguOSA3NS40MTMzIDQ4LjgyNSA3NS40MTMzIDQ3LjU4NzVDNzUuNDEzMyA0Ny40NzUgNzUuMzM4MyA0Ny40IDc1LjI2MzMgNDcuNEg3MS40MzgzQzcxLjM2MzMgNDcuNCA3MS4yODgzIDQ3LjQ3NSA3MS4yODgzIDQ3LjU4NzVDNzEuMjg4MyA1MC44MTI1IDc0LjQwMDggNTIuNDYyNSA3Ny40MzgzIDUyLjQ2MjVDODAuNDc1OCA1Mi40NjI1IDgzLjU4ODMgNTAuNzc1IDgzLjU4ODMgNDcuNTg3NUM4My42MjU4IDQ1LjE1IDgxLjM3NTggNDMuODM3NSA3OS4xMjU4IDQzLjU3NVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yOS45NjE4IDM3LjVDMjguODM2OCAzNy41IDI3Ljc4NjggMzcuODM3NSAyNi45MjQzIDM4LjUxMjVWMzAuOTM3NUMyNi45MjQzIDMwLjgyNSAyNi44NDkzIDMwLjc1IDI2LjczNjggMzAuNzVIMjMuMDI0M0MyMi45MTE4IDMwLjc1IDIyLjgzNjggMzAuODI1IDIyLjgzNjggMzAuOTM3NVY1MS45QzIyLjgzNjggNTIuMDEyNSAyMi45MTE4IDUyLjA4NzUgMjMuMDI0MyA1Mi4wODc1SDI2LjczNjhDMjYuODQ5MyA1Mi4wODc1IDI2LjkyNDMgNTIuMDEyNSAyNi45MjQzIDUxLjlWNDQuOTYyNUMyNi45MjQzIDQzLjE2MjUgMjcuODYxOCA0MS4zMjUgMjkuOTYxOCA0MS4zMjVDMzIuMDYxOCA0MS4zMjUgMzIuOTk5MyA0My4xNjI1IDMyLjk5OTMgNDQuOTYyNVY1MS44NjI1QzMyLjk5OTMgNTEuOTc1IDMzLjA3NDMgNTIuMDUgMzMuMTg2OCA1Mi4wNUgzNi44OTkzQzM3LjAxMTggNTIuMDUgMzcuMDg2OCA1MS45NzUgMzcuMDg2OCA1MS44NjI1VjQ1QzM3LjA4NjggNDAuNzI1IDM0LjAxMTggMzcuNSAyOS45NjE4IDM3LjVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNNDkuNjQ5NiA0NUM0OS42NDk2IDQ3LjAyNSA0OC4wNzQ2IDQ4LjYzNzUgNDYuMTI0NiA0OC42Mzc1QzQ0LjE3NDYgNDguNjM3NSA0Mi41OTk2IDQ2Ljk4NzUgNDIuNTk5NiA0NUM0Mi41OTk2IDQzLjAxMjUgNDQuMTc0NiA0MS4zNjI1IDQ2LjEyNDYgNDEuMzYyNUM0OC4wNzQ2IDQxLjM2MjUgNDkuNjQ5NiA0Mi45NzUgNDkuNjQ5NiA0NVpNNDYuMDQ5NiAzNy41QzQxLjg4NzEgMzcuNSAzOC41MTIxIDQwLjg3NSAzOC41MTIxIDQ1QzM4LjUxMjEgNDkuMTI1IDQxLjg4NzEgNTIuNSA0Ni4wNDk2IDUyLjVDNDcuNDM3MSA1Mi41IDQ4Ljc4NzEgNTEuNzg3NSA0OS43NjIxIDUwLjU4NzVWNTEuOUM0OS43NjIxIDUyLjAxMjUgNDkuODM3MSA1Mi4wODc1IDQ5Ljk0OTYgNTIuMDg3NUg1My40MzcxQzUzLjU0OTYgNTIuMDg3NSA1My42MjQ2IDUyLjAxMjUgNTMuNjI0NiA1MS45VjQ1QzUzLjU4NzEgNDAuODc1IDUwLjIxMjEgMzcuNSA0Ni4wNDk2IDM3LjVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNNjYuMDc0NiA0NUM2Ni4wNzQ2IDQ3LjAyNSA2NC40OTk2IDQ4LjYzNzUgNjIuNTg3MSA0OC42Mzc1QzYwLjY3NDYgNDguNjM3NSA1OS4wOTk2IDQ2Ljk4NzUgNTkuMDk5NiA0NUM1OS4wOTk2IDQzLjAxMjUgNjAuNjc0NiA0MS4zNjI1IDYyLjU4NzEgNDEuMzYyNUM2NC40OTk2IDQxLjM2MjUgNjYuMDc0NiA0Mi45NzUgNjYuMDc0NiA0NVpNNjIuNTg3MSAzNy41QzU4LjQyNDYgMzcuNSA1NS4wMTIxIDQwLjg3NSA1NS4wMTIxIDQ1QzU1LjAxMjEgNDkuMTI1IDU4LjQyNDYgNTIuNSA2Mi41ODcxIDUyLjVDNjYuNzQ5NiA1Mi41IDcwLjE2MjEgNDkuMTI1IDcwLjE2MjEgNDVDNzAuMTYyMSA0MC44NzUgNjYuNzQ5NiAzNy41IDYyLjU4NzEgMzcuNVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xNS4zMzg0IDQ4LjM3NUMxMy4zODg0IDQ5LjIgMTEuMTM4NCA0OC4yNjI1IDEwLjQyNTkgNDYuMjc1QzkuNzg4NDIgNDQuNTEyNSAxMC42MTM0IDQyLjUyNSAxMi4zMDA5IDQxLjdDMTMuNTc1OSA0MS4xIDE1LjAwMDkgNDEuMjg3NSAxNi4wNTA5IDQyLjA3NUMxNi4xNjM0IDQyLjE1IDE2LjI3NTkgNDIuMTUgMTYuMzg4NCA0Mi4xMTI1TDE5LjUzODQgNDAuNzYyNUMxOS43MjU5IDQwLjY4NzUgMTkuODAwOSA0MC40MjUgMTkuNjUwOSA0MC4yMzc1QzE3LjQ3NTkgMzcuNjUgMTMuNzI1OSAzNi43MTI1IDEwLjUwMDkgMzguMzI1QzcuMDUwOTIgNDAuMDUgNS40NzU5MiA0NC4xNzUgNi44NjM0MiA0Ny43Mzc1QzguNDM4NDIgNTEuNzEyNSAxMi45NzU5IDUzLjU4NzUgMTYuODc1OSA1MS45QzIwLjAyNTkgNTAuNTUgMjEuNzUwOSA0Ny4yODc1IDIxLjMzODQgNDQuMDYyNUMyMS4zMDA5IDQzLjgzNzUgMjEuMDc1OSA0My43MjUgMjAuODg4NCA0My44TDE3LjczODQgNDUuMTVDMTcuNjI1OSA0NS4xODc1IDE3LjU1MDkgNDUuMyAxNy41NTA5IDQ1LjQxMjVDMTcuNDAwOSA0Ni42ODc1IDE2LjU3NTkgNDcuODEyNSAxNS4zMzg0IDQ4LjM3NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

const BLACK_LOGO =
  "data:image/svg+xml;base64,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";

const Widgets = ({ widgets }) => {
  return (
    <div>
      {widgets.map((w) => (
        <React.Fragment key={w.id}>
          {React.createElement(WIDGETS[w.component], w.settings)}
        </React.Fragment>
      ))}
    </div>
  );
};

const SlimIcon = ({ name }) => {
  const icon = SLIM_ICONS[name];

  if (icon.type === "b64") {
    return (
      <span className={s["slim-icon"]}>
        <img src={icon.icon} />
      </span>
    );
  }

  if (icon.type === "svg") {
    return (
      <span
        className={s["slim-icon"]}
        style={{ height: icon.height, width: icon.width }}
      >
        {icon.icon}
      </span>
    );
  }

  throw "Unknown icon format!";
};

const Item = ({ item }) => (
  <a href={item.url} className={s["nav-item"]} id={item.id}>
    <strong>{item.label}</strong>
  </a>
);

const SubMenu = ({ item }) => {
  const [open, setNavigation] = React.useState(false);

  return (
    <span
      href="#"
      className={`${s["nav-item"]} ${s["has-submenu"]} ${
        open ? s["submenu-open"] : ""
      }`}
    >
      <strong onClick={() => setNavigation(!open)}>{item.label}</strong>
      <div className={s["nav-sub"]}>
        <Container>
          {item.rows.map((row) => (
            <div key={row.id} className={s["nav-cols"]}>
              {row.columns.map((col) => (
                <Widgets key={col.id} widgets={col.widgets} />
              ))}
            </div>
          ))}
        </Container>
      </div>
    </span>
  );
};

const Logo = ({ currentLanguage, overwrite }) => {
  if (overwrite) {
    return (
      <a href={`https://www.chaos.com/${currentLanguage}`}>
        <img src={BLACK_LOGO} className={s.logo} alt="Chaos" />
      </a>
    );
  } else {
    return (
      <a href={`https://www.chaos.com/${currentLanguage}`}>
        <img src={RED_LOGO} className={s.logo} alt="Chaos" />
      </a>
    );
  }
};

const UserLogoutButton = ({ logOutButton }) =>
  logOutButton && (
    <div
      className={`${s["user-logout"]} ${s[`user-logout-${logOutButton.type}`]}`}
    >
      <SimpleButton settings={logOutButton} />
    </div>
  );

const MobileNav = ({ languages, onChangeLanguage }) => (
  <div className={s["mobile-nav"]}>
    <div className={s["header-langs"]}>
      <div className={s["link-wrapper"]}>
        {languages.map((lang) => (
          <a
            key={lang.code}
            href={lang.link}
            onClick={
              onChangeLanguage
                ? (event) => {
                    // TODO: We were not preventing the default in the previos header
                    // implementation. Should we prevent it now or stick to the original?
                    event.preventDefault();
                    onChangeLanguage(lang.code, lang.link);
                  }
                : null
            }
          >
            {lang.code}
          </a>
        ))}
      </div>
    </div>
  </div>
);

const Navigation = ({ menu, languages, onChangeLanguage }) => (
  <div className={s.nav}>
    {menu.map((item, idx) => (
      <React.Fragment key={idx}>
        {item.rows.length > 0 && <SubMenu key={item.id} item={item} />}

        {item.rows.length === 0 && <Item key={item.id} item={item} />}
      </React.Fragment>
    ))}

    <MobileNav languages={languages} onChangeLanguage={onChangeLanguage} />
  </div>
);

const LanguageLink = ({ lang, onChangeLanguage, afterChange }) => (
  <a
    href={lang.link}
    onClick={
      onChangeLanguage
        ? (event) => {
            // TODO: We were not preventing the default in the previos header
            // implementation. Should we prevent it now or stick to the original?
            event.preventDefault();
            onChangeLanguage(lang.code, lang.link);
            afterChange();
          }
        : null
    }
  >
    {lang.label}
  </a>
);

const LanguageSwitcher = ({
  showLanguages,
  currentLanguage,
  languages,
  onChangeLanguage,
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      {showLanguages !== false && (
        <span className={`${s["slim-item"]} ${s["sub-menu"]}`}>
          <ClickAway onAwayClick={() => setOpen(false)}>
            <span
              className={s["inner-slim-item"]}
              onClick={() => setOpen(!open)}
            >
              <SlimIcon name="globe" />
              <span className={s["current-language"]}>{currentLanguage}</span>
            </span>

            {open && (
              <div className={s.sub}>
                {languages.map((lang) => (
                  <React.Fragment key={lang.code}>
                    {lang.code.toLowerCase() ===
                      currentLanguage.toLowerCase() && (
                      <div className={s["current-language-wrapper"]}>
                        <SlimIcon name="check" />
                        <LanguageLink
                          lang={lang}
                          onChangeLanguage={onChangeLanguage}
                          afterChange={() => setOpen(false)}
                        />
                      </div>
                    )}

                    {lang.code.toLowerCase() !==
                      currentLanguage.toLowerCase() && (
                      <div className={s["language-wrapper"]}>
                        <LanguageLink
                          lang={lang}
                          onChangeLanguage={onChangeLanguage}
                          afterChange={() => setOpen(false)}
                        />
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            )}
          </ClickAway>
        </span>
      )}
    </React.Fragment>
  );
};

const linkDecorator = (link, returnUrl) =>
  link && link.replace("RETURN_URL", returnUrl);

const prepAccountMenu = (menu, returnUrl) =>
  menu.map((e) => ({
    link: { ...e.link, link: linkDecorator(e.link.link, returnUrl) },
    icon: { ...e.icon },
  }));

const Icon = ({ src }) => (
  <div className={s.icon}>
    {src && src.urls && src.urls.original && (
      <img src={src.urls.original} alt={src.title} />
    )}
  </div>
);

const extractAvatarContent = (user) => {
  if (!user || !user.fullName) {
    return "";
  }

  const [first, last] = user.fullName.split(" ");

  return `${first && first[0]}${last && last[0]}`;
};

const UserMenu = ({
  user,
  signInLink,
  returnUrl,
  accountMenu,
  logOutButton,
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      {user && (
        <span className={`${s["slim-item"]} ${s["sub-menu"]}`}>
          <ClickAway onAwayClick={() => setOpen(false)}>
            <div onClick={() => setOpen(!open)} className={s["user-avatar"]}>
              {extractAvatarContent(user)}
            </div>

            {open && (
              <div className={`${s.sub} ${s["user-sub"]}`}>
                <div className={s["user-header"]}>
                  <h5>{user.fullName}</h5>
                  <div className={s.email}>{user.email}</div>
                </div>

                <div className={s["user-inner-menu"]}>
                  {prepAccountMenu(accountMenu, returnUrl).map(
                    ({ link, icon }, idx) => (
                      <a
                        key={idx}
                        href={link.link}
                        id={link.id}
                        className={s[link.className]}
                      >
                        <Icon src={icon} />

                        {link.label}
                      </a>
                    ),
                  )}
                </div>

                <UserLogoutButton
                  logOutButton={Object.assign(logOutButton, {
                    link: linkDecorator(
                      logOutButton && logOutButton.link,
                      returnUrl,
                    ),
                  })}
                />
              </div>
            )}
          </ClickAway>
        </span>
      )}

      {!user && signInLink && (
        <a
          key={signInLink.id}
          href={linkDecorator(signInLink.link, returnUrl)}
          className={`${s["slim-item"]} ${s["fake-user-avatar"]}`}
          id={signInLink.id}
        >
          <span className={s["inner-slim-item"]}>
            <SlimIcon name="user" />
            <span>{signInLink.label}</span>
          </span>
        </a>
      )}
    </React.Fragment>
  );
};

const UserMenuMobile = ({
  user,
  signInLink,
  returnUrl,
  accountMenu,
  logOutButton,
  open,
  onToggle,
}) => (
  <div className={s["user-mobile"]}>
    {user && (
      <React.Fragment>
        <button
          type="button"
          className={s["user-toggle"]}
          onClick={() => onToggle(!open)}
        >
          <div className={s["user-avatar"]}>{extractAvatarContent(user)}</div>
        </button>

        {open && (
          <div className={s["user-mobile-menu"]}>
            <ButtonClose onClick={() => onToggle(false)} />

            <div className={s["user-header"]}>
              <h4>{user.fullName}</h4>
              <div className={s.email}>{user.email}</div>
            </div>

            <div className={s["user-inner-menu"]}>
              {prepAccountMenu(accountMenu).map(({ link, icon }, idx) => (
                <a
                  key={idx}
                  href={link.link}
                  className={`${s["user-mobile-link"]} ${s[link.className]}`}
                  id={link.id}
                >
                  <Icon src={icon} />

                  <span>{link.label}</span>
                </a>
              ))}
            </div>

            <UserLogoutButton
              logOutButton={Object.assign(logOutButton, {
                link: linkDecorator(
                  logOutButton && logOutButton.link,
                  returnUrl,
                ),
              })}
            />
          </div>
        )}
      </React.Fragment>
    )}

    {!user && signInLink && (
      <a
        key={signInLink.id}
        href={linkDecorator(signInLink.link, returnUrl)}
        className={s["user-toggle"]}
      >
        <SlimIcon name="mobileUser" />
      </a>
    )}
  </div>
);

const SlimNavItems = ({ slimNavigation }) => {
  return slimNavigation.map((nav, idx) => {
    return (
      <a
        key={nav.id}
        className={
          idx === slimNavigation.length - 1
            ? `${s["slim-item-last"]} ${s["slim-item"]}`
            : s["slim-item"]
        }
        href={nav.link.link}
      >
        <span className={s["inner-slim-item"]}>
          {nav.icon && (
            <span className={s["slim-icon"]}>
              <img src={nav.icon.urls.original} />
            </span>
          )}
          <span>{nav.link.label}</span>
        </span>
      </a>
    );
  });
};

const SlimNavigation = ({ laguageSwitcher, userMenu, slimNavigation }) => {
  const cart = React.useContext(CartContext);

  return (
    <div className={s.slim}>
      {slimNavigation && slimNavigation.length > 0 && (
        <SlimNavItems slimNavigation={slimNavigation} />
      )}

      {cart && cart.component && cart.component()}

      <LanguageSwitcher {...laguageSwitcher} />

      <UserMenu {...userMenu} />
    </div>
  );
};

const Buttons = ({ button_1, button_2, button_1_items, button_2_items }) => (
  <div className={s.buttons}>
    <Button settings={button_1} menu={button_1_items} />
    <Button settings={button_2} menu={button_2_items} />
  </div>
);

const MobileSticky = () => (
  <div className={s["mobile-sticky"]}>
    <a href="https://store.chaos.com" className={s["main-cta"]}>
      Buy online
    </a>

    <div className={s["link-wrapper"]}>
      <a href="/how-to-buy/resellers">Find a reseller</a>
      <a href="/renewal">Renew or upgrade</a>
    </div>
  </div>
);

const SearchToggle = ({ onClick }) => (
  <button type="button" className={s["search-toggle"]} onClick={onClick}>
    Search
  </button>
);

const searchVisible = ({ search }) =>
  search && search.enabled && search.visible;

export default function Header({
  data,
  user,
  returnUrl,
  showLanguages,
  currentLanguage,
  languages,
  cart,
  onChangeLanguage,
}) {
  const [navigation, setNavigation] = React.useState(false);
  const [profile, setProfile] = React.useState(false);
  const [search, setSearch] = React.useState(false);

  const handleOpenSearch = () => setSearch(true);
  const handleCloseSearch = () => setSearch(false);

  return (
    <CartContext.Provider value={cart}>
      <div
        className={`${s.header} ${navigation ? s.open : ""} ${
          profile ? s["profile-open"] : ""
        }`}
      >
        <Logo
          currentLanguage={currentLanguage}
          overwrite={data.overwrite_logo}
        />

        <div className={s.content}>
          <nav>
            <div className={s["slim-wrapper"]}>
              <SlimNavigation
                slimNavigation={data.slim_navigation}
                laguageSwitcher={{
                  currentLanguage,
                  languages,
                  onChangeLanguage,
                  showLanguages,
                }}
                userMenu={{
                  user,
                  returnUrl,
                  signInLink: data.sign_in_link,
                  accountMenu: data.account_menu,
                  logOutButton: data.account_menu_logout_button,
                }}
              />
            </div>

            <div className={s.actions}>
              <div className={s["navigation-wrapper"]}>
                <Navigation
                  menu={data.mega_menu}
                  languages={languages}
                  onChangeLanguage={onChangeLanguage}
                />
                {searchVisible(data) && (
                  <SearchToggle onClick={handleOpenSearch}>Search</SearchToggle>
                )}
              </div>

              <Buttons
                button_1={data.button_1}
                button_2={data.button_2}
                button_1_items={data.button_1_items}
                button_2_items={data.button_2_items}
              />

              <div className={s["mobile-actions"]}>
                {cart && cart.component && cart.component()}

                <UserMenuMobile
                  user={user}
                  returnUrl={returnUrl}
                  signInLink={data.sign_in_link}
                  accountMenu={data.account_menu}
                  logOutButton={data.account_menu_logout_button}
                  open={profile}
                  onToggle={setProfile}
                />

                {searchVisible(data) && (
                  <SearchToggle onClick={handleOpenSearch}>Search</SearchToggle>
                )}

                <Hamburger
                  open={navigation}
                  onClick={() => {
                    if (profile) setProfile(false);
                    else setNavigation(!navigation);
                  }}
                />
              </div>
            </div>
          </nav>
        </div>

        {searchVisible(data) && (
          <Search
            visible={search}
            onClose={handleCloseSearch}
            search={data.search}
          />
        )}
      </div>
    </CartContext.Provider>
  );
}
